<template>
    <div class="terms">
        <pre class="text">
        第1章总则
        (使用条款的目的)
        第一条 株式会社ブレインスリープ（以下简称 "本公司"）制定了《睡眠偏差値forBiz使用条款》（以下简称 "本条款"）。 并将根据本条款提供「睡眠偏差値forBiz」（以下简称 "本服务"）。
        
        (对条款的修改)
        第2条 本公司变更本使用条款的全部或部分内容时，应事先征得用户的同意。 但是，当使用条款的变更符合用户的一般利益，且使用条款的变更不违背合同订立的目的时，根据变更的必要性、变更后内容的合理性、是否存在可以变更的条款及其内容等与变更有关的情况，当变更是合理的情况下，本公司将不进行通知。
        
        (术语定义)
        第三条 在本条款中，下列术语具有以下含义：
        术语的含义
        (1) "电信设施"是指进行电信的机器、器具、线路和其他电力设施。
        (2) "自营终端设施"是指用户使用的终端设施。
        (3) "睡眠偏差値forBiz "是指通过本公司安装的服务器设施及其他通信设施，提供应用程序等判断睡眠质量的服务。
        (4) "用户"是指使用睡眠偏差値forBiz来判断睡眠质量的人。
        (5) "用户ID"由本公司定义的任意字母和数字组合而成，用于识别使用人。
        
        (对条款的修改)
        第2条 本公司变更本使用条款的全部或部分内容时，应事先征得用户的同意。 但是，当使用条款的变更符合用户的一般利益，且使用条款的变更不违背合同订立的目的时，根据变更的必要性、变更后内容的合理性、是否存在可以变更的条款及其内容等与变更有关的情况，当变更是合理的情况下，本公司将不进行通知。
        
        第3章 使用
        (禁止转让权利)
        第五条 接受本服务的权利仅属于用户，用户不得将接受本服务的权利转让、继承、出售、抵押或以其他方式抵押给任何第三方。
        
        第4章 禁止的行为
        (禁止商业活动)
        第六条 用户不得向他人再提供本公司的全部或部分本服务，无论收费或免费。
        (版权等)
        第七条 本公司在本服务中向用户提供的所有物品等(包括本条款、各种软件、操作手册、网站、邮件杂志等)的著作权、专利权、商标权、专有技术等知识产权均属于本公司或允许本公司使用该物品等的人。
        2 用户应按以下方式处理前款的物品等。
        (1)请勿用于本服务以外的任何目的。
        (2)不得复制、修改、编辑等，不得进行反向工程、反编译、反汇编。
        (3)无论是否出于商业目的，您不得向任何第三方出借、转让、抵押等。
        (4)不删除或更改本公司或本公司的签约本服务提供者所展示的与提供本服务不可缺少的版权声明等。
        
        第5章 暂停使用等
        (停止使用)
        第八条 本公司可自行决定随时停止使用本服务的全部或部分内容。 但应在本公司网站(https://suiminhensachi.com/)上提前通知后进行。
        2当本公司根据前款规定暂停使用本服务时，本公司应通过互联网及本公司认为合适的其他方式提前告知。 但是，在不可避免的紧急情况下，本条不适用。
        (暂停使用)
        第九条 本公司可自行决定随时暂停使用全部或部分服务的使用。 但应事先在本公司网站（https://suiminhensachi.com/）上公告后进行。
        (终止提供服务)
        第十条 本公司可随时自行决定终止提供全部或部分服务。 但本公司应在终止日期前至少30天在本公司网站（https://suiminhensachi.com/）上发出通知。
        
        第6章 费用
        (费用)
        第十一条 本公司提供的本服务将产生费用。具体收费金额应在个人合同中另行规定。
        
        第7章 损害赔偿
        (责任限制)
        第十二条 因本公司服务器设备或其他电信设施中存储的数据丢失而造成的损失，本公司不承担任何责任。 用户应自行备份数据，风险自担。
        (免责声明)
        第十三条 本公司可随时变更本服务的功能。 内容、服务和软件如有变更，恕不另行通知。
        2 您同意以下内容:由于前款内容的变更，可能会导致数据、功能、效用的损失，用户同意本本公司将根据本服务进行前款内容的变更，除法律另有规定外，本公司对数据、内容、功能、效用的损失不承担任何责任。 
        3 即使因使用本服务而发生故障或损害，本公司也不承担任何责任（包括但不限于赔偿和补偿）。
        4 如果用户因使用本服务给第三方造成损害的，用户应负责解决该损害。
        5 因使用本服务而产生的任何后果，无论原因如何，如提供本服务所必需的设备发生故障或失效、第三方的擅自侵入、商业纠纷、基于法律法规的强制处置等，本公司不承担任何责任。
        6本司对用户因根据第八条（停止使用）、第九条（暂停使用）或第十条（终止提供服务）中断、暂停、限制使用或终止提供服务而造成的任何损失或损害不承担任何责任。
        7 本公司对因网络恐怖主义、自然灾害、第三方干扰等不可预见的情况造成的损失不承担任何责任。 (网络恐怖主义是指通过计算机网络入侵国防、公共安全等各个领域的计算机系统，通过破坏或篡改数据等手段使国家或社会的重要基础设施失去功能的恐怖主义行为。)
        
        第8章 个人信息的处理
        (关于个人信息的处理)
        第十四条 本公司将获取用户基于本服务进行的调查等的所有信息(以下简称 "回应信息")。 
        2 用户同意本公司将回应信息作为不识别个人的统计信息，用于以下目的。
        (1)确认调查结果、分析，以及进行市场调查所需的其他事项。
        (2)开发产品和解决方案以及实施修改所需的事项。
        (3)开展研讨会、活动、运动等所需事项。
        (4)定向广告的发布
        (5)实施研究和调查所需的事项。
        (6)开发和完善广告服务模型、购买预测模型等营销解决方案。
        (7)重新研究和补充诊断。
        (8)其他与上述事项有关的附带事项。
        3 本公司有可能会将回应信息作为不能直接识别特定个人的信息，提供给与本公司有合同关系的第三方，用于前述目的。
        
        第9章 维护
        (用户的部分责任)
        第十五条 当用户无法使用本服务时，用户应确认使用本服务的终端设备无故障，才能要求本公司进行维修。
        2 根据用户的要求，本公司将在营业厅进行睡眠偏差测试，并将结果通知用户。
        
        第10章 其他规定
        (接受的限制)
        第十六条 本公司收到用户提出的施工或其他服务请求时，如果技术上难以接受，或服务维护极度困难，或有其他妨碍本公司业务开展的情况，本公司可以不接受该请求。 在这种情况下，我们会通知用户原因。若本条款中另有规定以该条款为准。
        (签约人与使用有关的义务)
        第十七条 签约人应注意保管好本公司授予的用户ID。
        2 用户应自行负责维护和管理自己的终端设施、通信线路及其他使用本服务所需的设施。
        (法律、法规规定的事项)
        第十八条 在提供或使用本服务时，涉及到法律法规的事宜以法律法规为准。
        (管辖法律)
        第十九条 本条款的形成、有效性、解释和执行应受日本法律管辖。
        (争端的解决)
        第二十条 如果就本条款的任何规定或本条款未规定的任何事项发生任何争议，双方应真诚协商，尽可能友好地解决该争议。
        2 与本条款有关的任何争议，东京地方法院为第一审专属法院。
        (排除反社会力量)
        第二十一条 用户声明并保证其不属于以下任何一项，且今后也不会属于以下任何一项。
        (1) 用户或其高级职员(董事、执行官或审计员)不属于以下类别：有组织犯罪集团(《防止有组织犯罪集团实施不正当行为法》(1991年第77号法)第2条第2项)、有组织犯罪集团成员(《防止有组织犯罪集团实施不正当行为法》第2条第6项)、不再是有组织犯罪集团成员未满5年的人或相当于这些人的人。 )、相当于犯罪集团成员的人、与犯罪集团或犯罪集团成员关系密切的人(以下单独或统称为 "犯罪集团成员等"。)
        (2) 用户的经营业务是由犯罪集团等控制的。
        (3) 就其所从事的业务而言，承认其利用犯罪集团成员等的权力及利用其能力图利，或雇用犯罪集团成员等。
        (4) 被认为向犯罪集团成员等提供资金、好处或不合理优待。
        (5) 该服务的履行将促进犯罪集团成员等的活动或有助于犯罪集团成员等的运作。
        2 如果用户属于以下任何一种情况，本公司可以立即停止提供本服务，而无需任何通知或要求。
        (1) 当用户违反第1款时。
        (2) 用户或第三方有下列行为之一时。
        ① 对本公司或其分包商提出暴力要求时。
        ➁ 超出本公司或其分包商法律责任的不合理要求。
        ③ 对本公司或其分包商有威胁性言语或暴力行为的。
        ④ 散布不实谣言或以欺骗、武力等手段损害本公司或本公司委托第三方信誉，或干扰本公司或本公司委托第三方业务的行为。
        ⑤ 与上述各项相当的其他行为。
        3 本公司根据前款规定暂停提供服务时，对用户造成的损失，本公司不承担赔偿责任。
        
        (通知)
        第二十二条
        用户姓名(公司名称、姓名)、地址、联系方式、联系人、联系人的联系方式等信息通知本公司，如有变更，应通知本公司。 本公司对因未通知而给用户造成的损失不承担任何责任。
        </pre>
        <!-- eslint-able -->
    </div>
</template>
<script>
    export default {}
</script>
<style lang="scss" scoped>
.text {
    max-width: 100%;
    white-space: pre-line;
    font-size: 13px;
}
</style>